import Service from '@/helpers/service'

export default {

    index(params) {
        return Service().get('inquiry/index', {params});
    },
    show(id) {
        return Service().get('inquiry/show/'+id);
    },
    create(params) {
        return Service().post('inquiry/create', params, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
        });
    },
    update(id, params) {
        return Service().post('inquiry/update/'+id, params, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
        });
    },
    delete(id) {
        return Service().post('inquiry/delete/'+id);
    },
}